import experiments from './experiments';

/**
 * Fetches an experiment by key.
 *
 * @param {EXPERIMENT_KEY} key The experiment's key.
 * @returns {(undefined | {variants: Object, name: string, description: string, id: string})}
 */
export const getExperimentByKey = key => {
  if (!key) {
    return undefined;
  }

  return experiments[key];
};
